<script lang="ts">
  import LayoutStore from "@shared/svelte/Stores/LayoutStore";
  import type { SharedOrder } from "@shared/types/Order";

  export let order: SharedOrder;

</script>

<div
  data-testid="pickup-delivery-summary-subheader"
  class="fizz-flex-row-responsive"
  class:fizz-text-medium={$LayoutStore.isDesktop}
  class:fizz-text-small={$LayoutStore.isMobile}
  class:fizz-flow-4={$LayoutStore.isMobile}
>
  <span data-testid="total-pickup-items">
    <span class="fizz-text-strong"> Items for pickup: </span>
    <span>
      {order.total_pickup_items}
    </span>
  </span>
  <span data-testid="total-delivery-items">
    <span class="fizz-text-strong"> Items for delivery: </span>
    <span>
      {order.total_delivery_items}
    </span>
  </span>
</div>
